import PropTypes from 'prop-types';
import Quote from '~/components/Generic/Quote';
import React, { Fragment } from 'react';
const QuoteSection = React.memo(function QuoteSection({ quotes }) {
  return (
    <Fragment>
      {quotes.map((quote) => (
        <Quote key={quote.id} quote={quote} />
      ))}
    </Fragment>
  );
});

QuoteSection.propTypes = {
  quotes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      author: PropTypes.string.isRequired,
      body: PropTypes.shape({
        text: PropTypes.string.isRequired,
      }).isRequired,
      image: PropTypes.shape({
        fluid: PropTypes.object.isRequired,
      }),
    })
  ),
};

export default QuoteSection;
